import { render, staticRenderFns } from "./attention.vue?vue&type=template&id=fc0c6cbe&scoped=true"
import script from "./attention.vue?vue&type=script&lang=js"
export * from "./attention.vue?vue&type=script&lang=js"
import style0 from "./attention.vue?vue&type=style&index=0&id=fc0c6cbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0c6cbe",
  null
  
)

export default component.exports